export default {
    SET_LIST(state, leads){
        state.list = leads
    },
    SET_CURRENT_LEAD(state, lead){
        state.current_lead = lead
    }
}